import React, { useEffect } from "react";
import { ABGroupServerData, ABVariantProvider, getABGroup } from "@utils/ab";
import { Box } from "@chakra-ui/react";
import { Footer } from "../components/Footer";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import {
  HOME_PAGE_CONTAINER_PROPS,
  HomePageCertifications,
  HomePageHeader,
  HomePageHero,
  HomePageIntro,
  HomePageIntroTutorials,
  HomePageTestimonials,
  HomePageTutorialTypes,
} from "../components/HomePage";
import { PageProps } from "gatsby";
import { PageSeo } from "@components/PageSeo";
import { signupTracer } from "@apollo/signup-tracer";
import { utmGrabber } from "@apollo/utm-grabber";

export const getServerData = getABGroup;

const HomePage = ({
  serverData,
}: PageProps<undefined, undefined, undefined, ABGroupServerData>) => {
  useEffect(() => {
    signupTracer("odyssey");
    utmGrabber();
  }, []);

  // (async () => {
  //   const res = await fetch('https://graphql-staging.api.apollographql.com/auth/sso/login?email=z@apollographql.com&returnToUrl=http://localhost:3000/docs', {
  //     credentials: 'include',
  //   })
  //   const json = await res.json();
  //   window.location.href = json.redirectUrl;
  // })()

  return (
    <>
      <GatsbySeo canonical="https://www.apollographql.com/tutorials/" />
      <PageSeo
        title="Learn with our GraphQL Tutorials, Examples, and Training"
        description="Level up with Apollo's official GraphQL tutorials. Get practical, hands-on trainings and become an Apollo GraphQL certified developer."
        socialTitle="GraphQL Tutorials"
        tagline="Boost your developer skills with our hands-on GraphQL tutorials and trainings"
      />
      <HomePageHeader />
      <HomePageHero />

      <HomePageIntroTutorials />
      <HomePageIntro />
      <HomePageTutorialTypes />
      <Box sx={HOME_PAGE_CONTAINER_PROPS}>
        <HomePageCertifications />
      </Box>

      <HomePageTestimonials
        {...HOME_PAGE_CONTAINER_PROPS}
        testimonials={[
          "More courses like this! By far the best set of tutorials for getting used to a new technology I've used in a long time.",
          "I really enjoyed this course, the new interactive question with drag and drop are cool, the performance of the instructors were cool too!",
          "I LOVE that you can skim through quickly, or dive deep. This is one of the best UX's I've seen for a course structure.",
          "Honestly, you put together an unreal tutorial so far. Nothing but gratitude here.",
          "Probably the best course out there to learn GraphQL",
          "I just wanted to say a huge thank you to all who worked to make this course so detailed an nice to follow. The way you structured the questions an videos inside the flow is amazing!",
        ]}
      />
      <Footer {...HOME_PAGE_CONTAINER_PROPS} borderTopWidth={0} />
    </>
  );
};

export default HomePage;
